import type {ReactNode} from 'react';
import styled from 'styled-components';
import {useAuth} from '../../auth/context/AuthContext';
import {TICKET_PERMS, hasTicketPerm} from '../../auth/utils/ticketPerms';

const DeniedContainer = styled.div`
	margin: 0 auto;
	max-width: 36rem;
	padding: 32px;
	text-align: center;
`;
const DeniedTitle = styled.h1`
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	color: #0f172a;
	margin: 0;
`;
const DeniedText = styled.p`
	margin: 8px 0 0;
	color: #475569;
`;

export function RequireAdmin({children}: {children: ReactNode}) {
	const {user} = useAuth();
	if (!user) return null;
	if (!hasTicketPerm(user.ticketPerms, TICKET_PERMS.ADMIN)) {
		return (
			<DeniedContainer>
				<DeniedTitle>403 — admin only</DeniedTitle>
				<DeniedText>You need admin access to view this page.</DeniedText>
			</DeniedContainer>
		);
	}
	return <>{children}</>;
}
